import { SingleOption } from '@cpm-pr1618001/ng-design-lib';
import { ExpenseShareTypes, SharingType } from '../../expenses-constants';

export interface NewExpense {
  createdByUserId: number;
  paidByUserId: number;
  expenseName: string;
  sharingType: SharingType;
  totalAmount: number;
  borrowers: Borrowers[];
  transactionDate: Date;
}

export interface Borrowers {
  borrowerUserId: number;
  borrowedAmount: number;
  splitPercentage?: number;
}

export interface NewExpenseFormValues {
  date: Date;
  lentTo: number[];
  paidBy: string;
  sharingType: SharingType;
  spentAmount: number;
  spentOn: string;
}

export interface AllocatedExpense {
  id: string;
  name: string;
  allocatedShare: string;
  splitAmount?: number;
}

export interface UpdateExpense {
  expenseName: string;
  paidByUserId: number;
  createdByUserId: number;
  sharingType: SharingType;
  totalAmount: number;
  transactionDate: string;
  borrowers: UpdateTransaction[];
}

export interface UpdateTransaction {
  borrowerUserId: number;
  borrowedAmount: number;
  paymentStatus: PaymentStatus;
  transactionId: number;
  splitPercentage?: number;
}

export interface PercentageAllocation {
  amount: number;
  percent?: string;
}

export enum ExpenseSubmitType {
  INITIAL = 'INITIAL',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum ExpenseOperationStatus {
  INITIAL = 'INITIAL',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum ExpenseRequestStatus {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface Expenses {
  createdAt: Date;
  firstName: string;
  lastName: string;
  paymentStatus: PaymentStatus;
  toPayAmount: number;
  toReceiveAmount: number;
  updatedAt: Date | null;
  userId: number;
}

export interface Transaction {
  firstName: string;
  lastName: string;
  transactionId: number;
  borrowerUserId: number;
  borrowedAmount: number;
  splitPercentage?: number;
  createdAt: Date;
  updatedAt: Date | null;
  expenseId: number;
  paymentStatus: PaymentStatus;
}

export interface UserExpenses {
  cardsTitle: Date;
  expenses: SelectedUserExpenses[];
}

export interface PaidBy {
  firstName: string;
  lastName: string;
  paidByUserId: number;
}

export interface CreatedBy {
  firstName: string;
  lastName: string;
  createdByUserId: number;
}

export interface SelectedUserExpenses {
  expenseName: string;
  paidAmount: number;
  createdAt: Date;
  updatedAt: Date | null;
  createdBy: CreatedBy;
  paidBy: PaidBy;
  sharingType: SharingType;
  transactionDate: Date;
  userId: number;
  expenseId: number;
  transactions: Transaction[];
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  PAYEE = 'PAYEE',
}

export interface InitExpensesState {
  expenseShareTypes: SingleOption[];
  newExpense: NewExpense;
  isNewExpenseSubmitProcessing: ExpenseSubmitType;
  updateExpenseSubmitProcessing: ExpenseOperationStatus;
  deleteExpenseSubmitProcessing: ExpenseOperationStatus;
  allocatedExpenses: AllocatedExpense[];
  expenses: Expenses[];
  selectedExpense: Expenses;
  selectedUserExpenses: SelectedUserExpenses[];
  selectedUserExpense: SelectedUserExpenses;
  expensesRequestStatus: ExpenseRequestStatus;
  selectedUserExpensesRequestStatus: ExpenseRequestStatus;
}

export const initialExpensesState: InitExpensesState = {
  expenseShareTypes: ExpenseShareTypes,
  newExpense: null,
  isNewExpenseSubmitProcessing: ExpenseSubmitType.INITIAL,
  updateExpenseSubmitProcessing: ExpenseOperationStatus.INITIAL,
  deleteExpenseSubmitProcessing: ExpenseOperationStatus.INITIAL,
  allocatedExpenses: [],
  expenses: [],
  selectedExpense: null,
  selectedUserExpenses: [],
  selectedUserExpense: null,
  expensesRequestStatus: ExpenseRequestStatus.INITIAL,
  selectedUserExpensesRequestStatus: ExpenseRequestStatus.INITIAL,
};
